import {
  Text,
  Img,
  Heading,
  Box,
  SimpleGrid,
  Flex,
  Button,
  Link,
  List,
  ListItem,
  ListIcon,
  VStack,
} from '@chakra-ui/react';

import React from 'react';
import { BiCircle } from 'react-icons/bi';
import { GoDotFill } from 'react-icons/go';

const information = [
  {
    title: 'IPEM Paris 2025 – The #1 International Private Capital Event',
    link: 'https://www.ipem-market.com/paris-2025/participate/',
    cover:
      'https://static.levocdn.com/WGLBUT82/IPEMParis25kitEarlyBird1200x625-8eRjG0NfmsA3p.jpg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          IPEM Paris is the #1 international private capital event in the world,
          where the entire ecosystem—LPs, GPs, advisors, and service
          providers—meets to do business. With 6,000+ private market leaders
          from 50 countries, unmatched networking tools, and exclusive
          experiences in the heart of Paris, it's designed to accelerate deals,
          relationships, and strategic thinking.
        </Text>

        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Massive scale: 6,000+ private market leaders, 1,300+ LPs, 900+ GPs
            from 50 countries all in one place.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Complete ecosystem: LPs, GPs, advisors, and service providers
            connecting to accelerate deals and partnerships.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Unmatched networking: Advanced tools, curated meetings, and
            exclusive social experiences in Paris.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            High-level content: Strategic conferences, curated summits, and
            insights on the latest market trends and opportunities.
          </ListItem>
          <Text fontWeight="bold" fontSize="14px">
            NEW in 2025: The IPEM LP Congress (Sept. 24)
          </Text>
          <List spacing={3} mt={4}>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Private, invitation-only summit for institutional LPs, sovereign
              wealth funds, and large family offices
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Dedicated, confidential environment for investment strategy
              discussions and peer engagement
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Away from the noise, but at the centre of the action
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Explore new opportunities with the world's leading institutional
              investors
            </ListItem>
          </List>
        </List>

        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: September 24–26, 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: Palais des Congrès, Paris
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Exclusive member discount until August 31st
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'SuperReturn Asia 2025 – Asia’s private capital. All in one place.',
    link: 'https://tinyurl.com/5dknsb97',
    cover:
      'https://static.levocdn.com/WGLBUT82/SuperReturnsSingapore-lDiwGcsXUwnm.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          SuperReturn Asia has cemented its position as the leading private
          markets event in Asia. The event is back and bigger than ever this
          September! Connect with 2,500+ senior private capital professionals
          from 50+ countries including 1,000+ GPs and 1,000+ LPs.
        </Text>

        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Big names. Bigger deals. Asia’s private capital all in one place.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Insights on private markets, fundraising outlook, secondaries,
            private credit, AI, deep tech, growth capital and more.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Unmatched networking: receptions, sightseeing, women’s lunch,
            acknowledgment ceremony and more.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Speakers from AllianceBernstein, Crescent Capital Partners, Hunter
            Point Capital, Park Square Capital, Everstone and more.
          </ListItem>
          <Text fontWeight="bold" fontSize="14px">
            New features for 2025 include:
          </Text>
          <List spacing={3} mt={4}>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              The AI & Deep Tech Investing Summit
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              SuperReturn Allocate: AI-powered, quickfire 1:1 meetings programme
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              The Acknowledgments Awards Ceremony
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              AGM meetings on 16 and 17 September
            </ListItem>
          </List>
        </List>
        <Box mt={5}>
          <Text fontWeight="bold" fontSize="14px">
            For more information or to register:
          </Text>
          <VStack align="start" spacing={2} mt={2}>
            <Text fontSize="14px">
              Call:{' '}
              <Link
                href="tel:+442080522013"
                color="#55B6A4"
                fontWeight="medium"
              >
                +44 (0) 20 8052 2013
              </Link>
            </Text>
            <Text fontSize="14px">
              Email:{' '}
              <Link
                href="mailto:gf-registrations@informaconnect.com"
                color="#55B6A4"
                fontWeight="medium"
              >
                gf-registrations@informaconnect.com
              </Link>
            </Text>
          </VStack>
        </Box>
        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 16th & 19th September 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: Marina Bay Sands Convention Centre, Singapore
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3539IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title:
      'SuperReturn Emerging Markets - High-growth economies Unlimited potential.',
    link: 'https://informaconnect.com/superreturn-emerging-markets/?vip_code=FKR3579IVCA&utm_source=IVCA%20partner&utm_medium=Email&utm_campaign=FKR3579%20-%20IVCA%20partner&utm_content=FKR3579IVCA',
    cover: 'https://static.levocdn.com/WGLBUT82/SuperReturns-tryCJ0UK3oVB.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          Mark your calendars, SuperReturn Emerging Markets is back from 16 - 18
          June! Join a global audience of 350+ industry experts including 100+
          LPs and 150+ GPs from over 45 countries worldwide.
        </Text>
        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />A three-day networking
            and learning experience you won’t find anywhere else.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Get the latest on the hottest industry topics including the shifting
            fundraising landscape, LP decision making, risk mitigation
            strategies and much more…
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Expect fresh perspectives from 120+ private capital leaders on the
            trends and disruptors shaping the industry.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            LPs attend for{' '}
            <a href="https://informaconnect.com/superreturn-emerging-markets/lp-offering/">
              free.
            </a>
          </ListItem>
        </List>

        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 16th & 18th June 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: Hotel Okura, Amsterdam
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3579IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'VietNam Innovation and Private Capital Summit (VIPC Summit) 2025',
    link: 'https://www.vpca.vn/vietnam-innovation-and-private-capital-summit',
    cover: 'https://static.levocdn.com/WGLBUT82/Banner3-yCr03MLq6gRo.jpg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          This summit has evolved since 2019 (prev. the Vietnam Venture Summit)
          into a broader, more dynamic platform to better reflect the
          opportunities across the entire private capital ecosystem.
        </Text>
        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            You’ll be in the room with 500+ invite-only guests from 20+
            countries, including Vietnam’s government officials, top investors,
            founders, and other key stakeholders. Engage in real, no-fluff
            conversations about what’s driving Vietnam’s Era of National Rise.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Co-hosted by the Ministry of Finance (MOF), the Vietnam National
            Innovation Center (NIC), the Vietnam Private Capital Association
            (VPCA), Do Ventures and Golden Gate Ventures (GGV), this exclusive
            event provides an invaluable platform to network and explore the
            future of private capital in Vietnam.
          </ListItem>
        </List>

        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 22nd & 23rd April 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: National Convention Center, Hanoi, Vietnam
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              As a IVCA member, you’re entitled to a free ticket by using the
              code <strong>IVCA</strong>.
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'SuperReturn Private Credit Asia',
    link: 'https://tinyurl.com/6c94ptw5',
    cover:
      'https://static.levocdn.com/WGLBUT82/SuperReturnsAsia-WT0jIrjfntYQd.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          SuperReturn Private Credit Asia is launching in Hong Kong this May!{' '}
          <br /> <br />
          Join 350+ private credit professionals including 120+ LPs and 150+ GPs
          for two days of meaningful connections and unmissable insights focused
          on the latest trends shaping global credit. <br />
        </Text>
        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            The agenda covers fundraising activity, direct lending, asset-backed
            lending, mezzanine, case studies on mid-market outlooks in Asia,
            Europe, the US, and much more.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Build valuable relationships through exclusive networking
            opportunities, including drinks receptions, LP/GP connections
            sessions, and a Women in Private Credit breakfast.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Learn from the leaders shaping private credit. Expert speakers
            include Stepstone Group, LuminArx Capital Management LP, Aksia,
            Merit Asset Management, Zerobridge, and more.
          </ListItem>
        </List>
        <Box mt={5}>
          <Text fontWeight="bold" fontSize="14px">
            For more information or to register:
          </Text>
          <VStack align="start" spacing={2} mt={2}>
            <Text fontSize="14px">
              Call:{' '}
              <Link
                href="tel:+442080522013"
                color="#55B6A4"
                fontWeight="medium"
              >
                +44 (0) 20 8052 2013
              </Link>
            </Text>
            <Text fontSize="14px">
              Email:{' '}
              <Link
                href="mailto:gf-registrations@informaconnect.com"
                color="#55B6A4"
                fontWeight="medium"
              >
                gf-registrations@informaconnect.com
              </Link>
            </Text>
          </VStack>
        </Box>
        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 7th & 8th May 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: JW Marriott | Hong Kong
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3635IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'SuperReturn China',
    link: 'https://tinyurl.com/fhprke35',
    cover: 'https://static.levocdn.com/WGLBUT82/SRChina-xloeaCAdEL6Ce.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          SuperReturn China is launching in Hong Kong this May!
          <br /> <br />
          Join 250+ senior decision makers including 100+ LPs and 120+ GPs for
          an entire day of meaningful connections and unmissable
          insights focused on Chinese and international markets. <br />
        </Text>
        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            The agenda offers the latest developments on the private markets
            outlook for China, fundraising strategies, AI &amp; deep tech, LP
            sentiment on Asia allocations, renewables, sustainable infra and
            energy transition, value creation, exit strategies and more!
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Build valuable relationships effortlessly through exclusive
            networking opportunities including drinks reception and LP/GP
            connections sessions.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Learn from the visionary leaders shaping private markets and venture
            capital. Expert speakers include Shanghainvest, HarbourVest
            Partners, Albourne Partners, Vietnman Investments Group, Starquest
            Capital and more.
          </ListItem>
        </List>
        <Box mt={5}>
          <Text fontWeight="bold" fontSize="14px">
            For more information or to register:
          </Text>
          <VStack align="start" spacing={2} mt={2}>
            <Text fontSize="14px">
              Call:{' '}
              <Link
                href="tel:+442080522013"
                color="#55B6A4"
                fontWeight="medium"
              >
                +44 (0) 20 8052 2013
              </Link>
            </Text>
            <Text fontSize="14px">
              Email:{' '}
              <Link
                href="mailto:gf-registrations@informaconnect.com"
                color="#55B6A4"
                fontWeight="medium"
              >
                gf-registrations@informaconnect.com
              </Link>
            </Text>
          </VStack>
        </Box>
        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 6th May 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: JW Marriott | Hong Kong
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3624IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'SuperReturn International Berlin',
    link: 'https://informaconnect.com/superreturn-international/',
    cover:
      'https://static.levocdn.com/WGLBUT82/SuperReturnsInternationalBerlin-pKk1luEBA6Lb.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          Private capital’s most senior gathering. <br />
          The most senior. The most global. The most LPs. The most connections.
        </Text>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          Don’t miss your chance to…
        </Text>
        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Meet more than 5,500+ senior decision-makers
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Connect with 1,800+ powerful LPs with $50T AUM, and 2,700+ GPs
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Hear from an incomparable line-up of 500+ industry heavyweight
            speakers
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />A truly global gathering
            from 70+ countries
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            View the delegate list &amp; arrange invaluable meetings ahead of
            time
          </ListItem>
        </List>
        <br />
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          Get the inside track on innovation, ESG, growth, private debt, value,
          secondaries, investing in sport, private wealth, regeneration and
          return <br />
          LPs already confirmed include AP1, CDPQ, GIC, Helmsley Charitable
          Trust, OTPP, Zurich Insurance Group and many more.
        </Text>
        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 2nd - 6th June 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: InterContinental Hotel, Berlin
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3584IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'Global Private Capital Conference',
    link: 'https://cvent.me/e5Mv3G',
    cover:
      'https://static.levocdn.com/WGLBUT82/GPCConference2025SocialPromo-dO45wphYsZSd.png',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          Join us at the GPC Conference 2025 in New York City from 7-9 April
          2025, at Convene 360 Madison. <br /> The Global Private Capital
          Conference is a must-attend event for investors, LPs and entrepreneurs
          looking to gain insights into global private capital and trends and
          opportunities across Asia, Latin America, Africa, CEE and the Middle
          East. <br />
          Participants include a curated group of family offices, endowments,
          pensions, sovereign wealth funds, development finance institutions,
          experienced fund managers and new investment teams active across
          private equity, venture capital, impact, infrastructure and credit. We
          look forward to insightful discussions and meaningful connections.
        </Text>
        <Box>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 7th & 9th April 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: New York City
          </Text>
          <Text
            mt="14px"
            variant="featureText"
            fontWeight={800}
            textAlign="justify"
          >
            IVCA Members get 15% Discount
          </Text>
        </Box>
      </>
    ),
  },
];

const PartnerEvents: React.FC = () => (
  <Flex
    justifyContent={{ xs: 'center', lg: 'flex-start' }}
    pl={{ xs: '0%', lg: '10%', xl: '8%' }}
    bgColor="bg.lightWhite"
    py="5px"
  >
    <Box id="media-coverage" pt={{ xs: '60px' }} maxW="container.2xl" w="90%">
      <Heading
        p="0"
        fontSize={{ xs: '22px', sm: '28px', md: '30px', lg: '42px' }}
        lineHeight={{ xs: '30px', md: '40px', lg: '54.6px' }}
        fontWeight="800"
      >
        Partner Events
      </Heading>
      <SimpleGrid
        w="100%"
        mt="24px"
        gap="2rem"
        columns={{ xs: 1, md: 2, xl: 3 }}
      >
        {information?.map((info) => (
          <Box
            boxShadow="md"
            borderRadius="xl"
            overflow="hidden"
            key={info?.title}
          >
            <Img height="250px" w="100%" src={info.cover} alt={info.title} />
            <Box p="1rem">
              <Heading as="h3" variant="featureTitle">
                {info.title}
              </Heading>
              <Box
                overflowY="scroll"
                css={{
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}
              >
                {typeof info?.desc === 'string' ? (
                  <Text variant="featureText" textAlign="justify">
                    {info?.desc}
                  </Text>
                ) : (
                  info?.desc
                )}
              </Box>
              <Link href={info.link} aria-label="learn-more" target="_blank">
                <Button
                  colorScheme="primary"
                  aria-label="learn-more"
                  w={{ xs: '175px' }}
                  h={{ xs: '30px', md: '40px' }}
                  mt="25px"
                >
                  {info.btnText}
                </Button>
              </Link>
            </Box>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  </Flex>
);

export default PartnerEvents;
